import { ME_COMPANY_INFO, CHANGE_PASSWORD, CHANGE_PASSWORD_IGNORE,
  ME_PAYMENT_INFO, ME_SERVICE_SIKDAE_INFO,
} from 'actions/auth';
import storage from 'helpers/storage';

function auth(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    // password 변경
    case `${CHANGE_PASSWORD}_FULFILLED`:
      return {
        ...state,
        changePWD: payload
      };
    case `${CHANGE_PASSWORD}_REJECTED`:
      return {
        ...state,
        changePWD: payload
      };
    case `${CHANGE_PASSWORD}_PENDING`:
      return {
        ...state,
        changePWD: payload
      };
    // password 30일 후 변경
    case `${CHANGE_PASSWORD_IGNORE}_FULFILLED`:
      return {
        ...state,
        ignore: payload
      };
    case `${CHANGE_PASSWORD_IGNORE}_REJECTED`:
      return {
        ...state,
        ignore: payload
      };
    case `${CHANGE_PASSWORD_IGNORE}_PENDING`:
      return {
        ...state,
        ignore: payload
      };

      case `${ME_COMPANY_INFO}_FULFILLED`:
        return {
          ...state,
          company: payload
        };
      case `${ME_COMPANY_INFO}_REJECTED`:
        return {
          ...state,
          company: payload
        };
      case `${ME_COMPANY_INFO}_PENDING`:
        return {
          ...state,
          company: payload
        };

        case `${ME_PAYMENT_INFO}_FULFILLED`:
          const { auth:authInfo } = (payload && payload.data) || {};
          
          if (authInfo) {
            const code = [];
            // const { auth: authInfo } = auth;
      
            if (authInfo.auth) {
              authInfo.auth.forEach((data) => {
                code.push(data.code);
              });
            }
      
            storage.set('info', {
              auth: {
                auth: code,
                organization: authInfo.organization,
                type: authInfo.type,
                depth: authInfo.depth
              }
            });
          } 
      
          return {
            ...state,
            captainPayment: payload && payload.data ? {...payload.data} : null
          };
        case `${ME_PAYMENT_INFO}_REJECTED`:
          return {
            ...state,
            captainPayment: payload
          };
        case `${ME_PAYMENT_INFO}_PENDING`:
          return {
            ...state,
            captainPayment: payload
          };

          case `${ME_SERVICE_SIKDAE_INFO}_FULFILLED`:
            return {
              ...state,
              service_sikdae: {...payload.data}
            };
          case `${ME_SERVICE_SIKDAE_INFO}_REJECTED`:
            return {
              ...state,
              service_sikdae: payload
            };
          case `${ME_SERVICE_SIKDAE_INFO}_PENDING`:
            return {
              ...state,
              service_sikdae: payload
            };
      
          default:
      return state;
  }
}

export default auth;
